module.exports = __webpack_public_path__ + "img/bg.1c6c8df3.png";